import { render, staticRenderFns } from "./CheckoutDrawer.vue?vue&type=template&id=b5df8636"
import script from "./CheckoutDrawer.vue?vue&type=script&lang=js"
export * from "./CheckoutDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports